<template>
	<div class="site">
    <div slot="container">
      <div class="base-search">
        <el-input placeholder="请输入内容" v-model="paramsObj.keyword" class="input-with-select" @keyup.enter.native="search" clearable
        @clear="search" style="width:240px">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <label>是否反馈:</label>
        <el-select style="width:140px" v-model="paramsObj.feedbackStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in feedbackStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <label>是否过期:</label>
        <el-select style="width:140px" v-model="paramsObj.expiredStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in expiredStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <label>是否标注:</label>
        <el-select style="width:140px" v-model="paramsObj.markStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in markStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="site.table">
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
					<el-table-column type="index" :index="(index) => {return index+ (paramsObj.page - 1) * paramsObj.pageSize + 1}" label="序号"
						align="center"></el-table-column>
					<el-table-column prop="investmentFirmsName" label="投资机构名称" align="center"></el-table-column>
          <el-table-column prop="enterprisesName" label="企业名称" align="center"></el-table-column>
          <el-table-column label="拟融资金额(万元)" align="center" prop="investmentAmount"></el-table-column>
          <el-table-column label="股权占比" align="center" prop="equityRatio"></el-table-column>
          <el-table-column prop="approvalStatus" label="审核状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.approvalStatus === 1">待审核</div>
              <div v-if="scope.row.approvalStatus === 2">不通过</div>
              <div v-if="scope.row.approvalStatus === 3">退回</div>
              <div v-if="scope.row.approvalStatus === 4">通过</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
							<el-button class="mini_btn" type="text" size="mini" @click="handleDetail(scope.row, true)">详情</el-button>
							<el-button style="margin-bottom: 5px;" size="mini" @click="openSiteModal(scope.row, false)" v-if="scope.row.approvalStatus === 1">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
						<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							:total="total" :current-page.sync="paramsObj.page" :page-size="paramsObj.pageSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>

		<!-- 新增机构 -->
		<el-dialog :title="titleDialog" :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false" @closed="is_submit = true" :append-to-body="true" class="site.dialog">
		 	<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
				<div class="form-title">企业经营信息</div>
        <el-row>
          <el-row>
            <el-form-item label="企业名称" prop="enterprisesName">
              <el-input v-model="ruleForm.enterprisesName" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
						<el-form-item label="投资金额" prop="investmentAmount	">
							<el-input v-model="ruleForm.investmentAmount" placeholder="请填写投资金额" disabled></el-input>
						</el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="股权占比" prop="equityRatio">
							<el-input v-model="ruleForm.equityRatio" placeholder="请填写股权占比" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="财报:" prop="financialReport" >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入财报"
                v-model="ruleForm.financialReport"
								disabled
              ></el-input>
            </el-form-item>
          </el-row>
					<el-row>
						<el-form-item label="附件材料:" prop="financialReportFileList" >
							<el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" disabled
							:on-remove="(file, fileList)=>handleRemove(file, fileList,'financialReportFileList')" :limit="1" :file-list="financialReportFileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'financialReportFileList')"
							list-type="picture">
								<el-button size="small" type="primary" disabled>上传附件材料</el-button>
							</el-upload>
						</el-form-item>
					</el-row>
          <el-row>
            <el-form-item label="阶段性总结:" prop="periodicSummary" >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入阶段性总结"
                v-model="ruleForm.periodicSummary"
								disabled
              ></el-input>
            </el-form-item>
          </el-row>
					<el-row>
						<el-form-item label="附件材料:" prop="periodicSummaryFileList" >
							<el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" disabled
							:on-remove="(file, fileList)=>handleRemove(file, fileList,'periodicSummaryFileList')" :limit="1" :file-list="periodicSummaryFileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'periodicSummaryFileList')"
							list-type="picture">
								<el-button size="small" type="primary" disabled>上传附件材料</el-button>
							</el-upload>
						</el-form-item>
					</el-row>

          <!-- 审核信息开始 -->
          <div class="form-title">审核信息</div>
          <el-row>
						<el-form-item label="审核状态" prop="approvalStatus">
							<el-select v-model="ruleForm.approvalStatus" placeholder="请选择审核状态" :disabled="disabled">
								<el-option label="待审核" :value="1"></el-option>
								<el-option label="不通过" :value="2"></el-option>
								<el-option label="退回" :value="3"></el-option>
								<el-option label="通过" :value="4"></el-option>
							</el-select>
						</el-form-item>
					</el-row>
          <el-row>
						<el-form-item label="审核意见" prop="auditOpinion">
							<el-input v-model="ruleForm.auditOpinion" placeholder="请填写审核意见" :disabled="disabled"></el-input>
						</el-form-item>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="附件上传" prop="reviewFileList">
                <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" :disabled="disabled"
									:on-remove="(file, fileList)=>handleRemove(file, fileList,'reviewFileList')" :limit="1" :file-list="reviewFileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'reviewFileList')"
									list-type="picture">
									<el-button size="small" type="primary" :disabled="disabled">上传附件材料</el-button>
								</el-upload>
              </el-form-item>
            </el-col>
          </el-row>

        </el-row>
      </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="createSite" v-if="!disabled">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import InputNumberRange from "../../../components/inputNumberRange"
	export default {
		components: {
			InputNumberRange
		},
		data() {
			return {
				financingTermList: [],
				guaranteeTypeList: [],
				reviewFileList: [],
				feedbackStatus: [
					{ value: 0, label: "未反馈" },
					{ value: 1, label: "已反馈" }
				], // 是否反馈
				expiredStatus: [
					{ value: 0, label: "未过期" },
					{ value: 1, label: "已过期" }
				], // 是否过期
				markStatus: [
					{ value: 0, label: "未标注" },
					{ value: 1, label: "已标注" }
				], // 是否标注
				titleDialog: "",
				listUrl: `${urlConfig.devUrl}apij2/admin-api/finance/needs-apply-manage/pageList`,
				financeRange: [], // 融资额度数组
				numberRange: [],
				financialReportFileList: [], // 财报附件
				periodicSummaryFileList: [], // 阶段性总结附件
				is_submit: true,
				headerStyle: {
					color: "#623AA2",
					background: "#E5F3FE",
				},
				paramsObj: {
					keyword: "",
					page: 1,
					pageSize: 10,
					financingType: 2
				},
				disabled: false,
				operationType: "add",
				searchValue: "",
				total: 20,
				dialogFormVisible: false,
				ruleForm: {
					approvalStatus: 1, // 审核状态
					auditOpinion: "", // 审核意见
					reviewFileList: "", // 审核附件
				},
				rules: {
					approvalStatus: [
						{ required: true, message: "请选择审核状态", trigger: ["blur", "change"] }
					],
				},
				tableData: [],
        image: "",
				id: 0
			};
		},
		methods: {
			// 获取数据字典
			getGroup(row) {
				let obj = {
					dictTypes: ["financial_financing_term", "corporate_financing_protection_method"]
				}
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
					(response) => {
						if (response.code == 0) {
							console.log('response', response)
							this.financingTermList = response.data.financial_financing_term
							this.guaranteeTypeList = response.data.corporate_financing_protection_method

							// this.ruleForm = response.data
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 10MB!");
        }
        return isLt2M;
      },
			handleRemove(file, fileList, type) {
				this[type] = fileList
				if(fileList.length === 0) {
					this.ruleForm[type] = ""
				}else{
					this.ruleForm[type] = JSON.stringify(fileList)
				}
			},
			handleAvatarSuccess(response, file, fileList, type) {
				if (response.code == 0) {
					this[type] = fileList

					this.fileListChange(type);
				}
			},
			fileListChange(type) {
				let arr = [];
				if (this[type].length > 0) {
					this[type].map(item => {
						arr.push({
							url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
							name: item.name
						});
					});
					this.ruleForm[type] = JSON.stringify(arr);

					// if (type === 'logoSrc' || type === 'realImageSrc') {
					//   this.ruleForm[type] = arr[0].url;
					// }
				} else {
					this.ruleForm[type] = '';
					this[type] = [];
				}
			},
			// 确认添加机构
			createSite() {
				if (!this.is_submit) {
					return;
				}
				this.is_submit = false;
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						let obj = {
							id: this.id,
							approvalStatus: this.ruleForm.approvalStatus,
							auditOpinion: this.ruleForm.auditOpinion,
							reviewFileList: this.ruleForm.reviewFileList
						}
							this.http
							.post(`${urlConfig.devUrl}apij2/admin-api/finance/needs-apply-manage/updateApprovalStatus`, obj)
								.then((res) => {
									if (res.code == 0) {

										this.$message.success("编辑成功！");
										this.getData();
										this.dialogFormVisible = false;
										this.reviewFileList = []
									} else {
										this.is_submit = true;
										this.$message.error(res.status);
									}
								}).catch(err => {
									this.is_submit = true;
								});
					} else {
						this.is_submit = true;

						console.log("error submit!!");
						return false;
					}
				})
			},
			// 新增
			openSiteModal(row) {
				this.id = row.id
				this.operationType = row ? "edit" : "add";
				this.dialogFormVisible = true;
				this.resetForm();

				if(this.operationType === "edit") {
					this.titleDialog = "编辑经营信息"
					this.getDetail(row)
					if(row.approvalStatus !== 1) {
						this.disabled = true
					}else{
						this.disabled = false
					}
				}
			},
			// 详情
			handleDetail(row) {
				this.titleDialog = "经营信息详情"
				this.operationType = "detail";
				this.getDetail(row)
				this.disabled = true
				this.dialogFormVisible = true;
			},

			// 获取金融产品详情
			getDetail(row) {
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/finance/needs-apply-manage/get?id=${row.id}`).then(
					(response) => {
						// this.ResetSearch(['searchValue'])

						if (response.code == 0) {
							console.log('response', response)
							this.ruleForm = response.data

							this.financialReportFileList = response.data.financialReportFileList ? JSON.parse(response.data.financialReportFileList) : [] // 财报附件
							this.periodicSummaryFileList = response.data.periodicSummaryFileList ? JSON.parse(response.data.periodicSummaryFileList) : [] // 阶段性总结附件
							this.reviewFileList = response.data.reviewFileList ? JSON.parse(response.data.reviewFileList) : []
							console.log('this.reviewFileList', this.reviewFileList)
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			resetForm() {
				this.ruleForm = {
					approvalStatus: 1, // 审核状态
					auditOpinion: "", // 审核意见:
					reviewFileList: "", // 审核附件
				}
			},
			//选择页码
			handleCurrentChange(e) {
				this.paramsObj.page = e;
				this.getData();
			},
			// 删除
			// handleDelete(row) {
			// 	this.$confirm("确定删除文件吗?", "提示", {
			// 			confirmButtonText: "确定",
			// 			cancelButtonText: "取消",
			// 			type: "warning",
			// 			center: true,
			// 		})
			// 		.then(() => {
			// 			this.http.request("Meeting_Field/" + row.id, "", "delete").then(
			// 				(response) => {
			// 					this.ResetSearch(['searchValue'])

			// 					if (response.code == 0) {
			// 						this.$message.success("删除成功！");
			// 						this.paramsObj.page = 1;
			// 						this.getData();
			// 					} else {
			// 						this.$message.error(response.status);
			// 					}
			// 				},
			// 				(error) => {}
			// 			);
			// 		})
			// 		.catch(() => {
			// 			this.$message({
			// 				type: "info",
			// 				message: "已取消删除",
			// 			});
			// 		});
			// },
			//搜索
			search() {
				this.getData();
			},
			getData() {
				this.http.post(this.listUrl, this.paramsObj).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.total;
					}
				});
			},
		},
		mounted() {
			this.getData();
			this.getGroup()
		},
	};
</script>
<style lang="scss">
	@include component(site) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}
		}
    .base-search {
			width: 100%;
			text-align: left;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.el-select {
				margin: 0 15px;
			}

			label{
				margin-left: 20px;
			}

			/deep/.el-input--suffix {
				width: 100%;
			}

			.el-input {
				margin: 0 15px;
			}

			.date-picker {
				margin: 0 15px;

				.el-range-separator {
					width: auto;
				}
			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			margin-right: 30px !important;
			background: #623aa2 !important;
			color: #fff;
			border: none;
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include component(rowItem) {
			width: 50%;
		}

		@include component(el-radio-group) {
			width: 100%;
			text-align: left;
		}

		@include part(dialog) {
			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			.avatar-uploader .el-upload:hover {
				border-color: #409eff;
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 178px;
				height: 130px;
				line-height: 130px;
				text-align: center;
			}

			.avatar {
				width: 178px;
				height: 178px;
				display: block;
			}

			.el-radio-group {
				display: flex;
			}
			.el-select{
					width: 100%;
				}
			.upload_btn {
				display: block;
				background-color: #00a1ff;
				font-weight: bold;
				color: #fff;
				padding: 2px;
				border-bottom-left-radius: 3px;
				border-bottom-right-radius: 3px;
			}

			.el-radio {
				display: flex;
				align-items: center;
			}

			.imgInput {
				background: url(../../../assets/add.png) no-repeat;
				border: none;
				text-indent: -2000px;
				height: 120px;
				padding: 10px;
				background-size: 70%;
				background-position: center;
				color: white;
				cursor: pointer;
			}

			.imgInput:focus {
				border: none;
				outline: 0;
			}

			.allPics {
				border: 1px solid #ccc;
				padding: 18px 15px 10px 20px;
				width: 90%;
				margin: 0 auto;
				margin-bottom: 30px;
				position: relative;
				// display: flex;
				// flex-wrap: wrap;
				// justify-content: space-between;
			}

			.allPics1 {
				display: flex;
				// flex-wrap: wrap;
			}

			.addPic-body {
				padding: 10px;
				height: 120px;
			}

			.addPic-close {
				position: absolute;
				top: 10px;
				right: 10px;
			}

			.addPic {
				max-width: 100%;
				max-height: 100%;
			}

			.el-form-item__content {
				text-align: left;
			}

			.form-title {
				width: 100%;
				text-align: left;
				color: #623aa2;
				border-left: 5px solid #623aa2;
				border-bottom: 1px solid #623aa2;
				padding-left: 10px;
				font-size: 20px;
				margin-bottom: 20px;
				font-weight: 700;
			}
		}

		.rowItem1 {
			float: left;
		}
	}
</style>
